
import Divider from '@mui/material/Divider';

export const DoctorCard = ({ doctorDetails }) => {
    return (
        <>
                <div className="flex flex-row flex-start align-center gap-4 ">
                    <img
                        style={{ width: '6rem', height: '6rem' }}
                        src={doctorDetails?.doctorImageUrl ||  "https://views.medibuddy.in/providerUi/assets/DoctorPlaceholder.svg"}
                        className='rounded-full object-contain'
                        alt="DoctorImage"
                    />
                    <div className="flex flex-start align-center flex-col  text-[#47566A] ">
                        <p className="font-light text-sm ">
                            {doctorDetails?.doctorSpecialization}
                        </p>
                        <div className="font-normal text-xl text-[#252D38">
                            {doctorDetails?.doctorprefix}{doctorDetails?.doctorprefix && "."} {doctorDetails?.doctorFirstName} {doctorDetails?.doctorLastName}
                        </div>
                        <div className="font-light text-base">
                            <div className="line-clamp-1">
                            {doctorDetails?.doctorQualification
                                    .map((item, index) => {
                                        if (typeof item === 'string') {
                                            return item;
                                        } else if (item) {
                                            return `${item?.qualification} ${item?.category? ' - '+ item?.category: ''}`;
                                        }
                                        return '';
                                    })
                                    .join(', ')}
                            </div>
                            <div className=""> {doctorDetails?.providerName} | {doctorDetails?.providerCity} </div>

                        </div>
                    </div>
                </div>
        </>
    )
}